module.exports = __webpack_public_path__ + "static/media/art3.c0e9f0b5.jpg";